import { makeObservable, action } from "mobx";
import { inject, observer } from "mobx-react";
import * as React from "react";
import { TextField, Separator, Grid, GridColumn, Button, Text, Notice } from "telia-front-react";
class AmountFieldComponent extends React.Component {
  constructor(props) {
    super(props);
    makeObservable(this, {
      onAmountChange: action.bound,
      clearAmountFieldChanges: action,
      changeAmount: action
    });
  }
  render() {
    return this.props.paymentStore.amountFieldState === "EDITING" ? this.getEditingAmountField() : this.getFinalAmountField();
  }
  getEditingAmountField() {
    const { translate } = this.props.translateStore;
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(TextField, { ...this.amountTextFieldProps() }), /* @__PURE__ */ React.createElement("span", { id: "payment-amount-textfield-description", style: { display: "none" } }, "€"), /* @__PURE__ */ React.createElement(Separator, { spacing: "xsmall", color: "invisible" }), /* @__PURE__ */ React.createElement(Grid, { align: ["center-xs"] }, /* @__PURE__ */ React.createElement(GridColumn, { align: ["middle-xs"], width: ["xs-6"], className: "text-left" }, /* @__PURE__ */ React.createElement(
      Button,
      {
        link: true,
        text: translate("payment.amount-field.clear-changes"),
        iconLeft: "#arrow-left",
        onClick: this.clearAmountFieldChanges
      }
    )), /* @__PURE__ */ React.createElement(GridColumn, { align: ["middle-xs"], width: ["xs-6"], className: "text-right" }, /* @__PURE__ */ React.createElement(
      Button,
      {
        type: "expressive",
        text: translate("payment.amount-field.apply-changes"),
        iconRight: "#arrow-right",
        onClick: this.changeAmount,
        disabled: this.props.paymentStore.amountFieldHasError
      }
    ))));
  }
  getFinalAmountField() {
    const { currentLanguage } = this.props.translateStore;
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("h2", null, this.getFinalAmountFieldHeading(), /* @__PURE__ */ React.createElement(Separator, { color: "invisible", spacing: "xxsmall" }), /* @__PURE__ */ React.createElement("span", { style: this.getCurrentAmountColor() }, currentLanguage === "en" ? "€" + this.props.paymentStore.parsedCurrentAmountByLanguage : this.props.paymentStore.parsedCurrentAmountByLanguage + " €")), !this.props.paymentProps.amountFieldReadOnly && this.getAmountFieldHelper());
  }
  getFinalAmountFieldHeading() {
    const amountHeading = this.getAmountHeading();
    if (amountHeading) {
      return /* @__PURE__ */ React.createElement("span", { id: "amount-heading-label", className: "text-normal text-bold" }, amountHeading);
    }
  }
  getAmountFieldHelper() {
    const { translate } = this.props.translateStore;
    if (this.props.paymentProps.brand === "SUPER") {
      return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Separator, { color: "invisible", spacing: "xxsmall" }), /* @__PURE__ */ React.createElement(Text, { className: "text-small" }, translate("payment.amount-helper.you-can-change"), this.getEditAmountButton()), /* @__PURE__ */ React.createElement(Separator, { color: "invisible", spacing: "xsmall" }));
    }
    return /* @__PURE__ */ React.createElement(Notice, { align: "center", size: "small", className: "text-light text-small" }, translate("payment.amount-helper.you-can-change"), this.getEditAmountButton());
  }
  amountTextFieldProps() {
    return {
      id: "payment-amount-textfield",
      label: this.props.paymentProps.amountFieldEditingLabel || this.props.translateStore.translate("payment.payment-sum"),
      "aria-describedby": "payment-amount-textfield-description",
      value: this.props.paymentStore.currentAmount,
      isInvalid: this.props.paymentStore.amountFieldHasError,
      onChange: this.onAmountChange,
      icon: "#currency-euro",
      errorMessage: this.amountFieldHelperProps()
    };
  }
  amountFieldHelperProps() {
    if (this.props.paymentStore.amountFieldHasError) {
      return this.amountFieldHelperText();
    }
  }
  amountFieldHelperText() {
    const { translate } = this.props.translateStore;
    if (this.props.paymentStore.amountFieldHasError) {
      return translate(this.props.paymentStore.amountFieldErrorLabel);
    }
  }
  onAmountChange(amount) {
    this.props.paymentStore.changeCurrentAmount(amount);
  }
  clearAmountFieldChanges = () => {
    this.props.paymentStore.setAmountFieldState("CANCELLED");
  };
  changeAmount = () => {
    this.props.paymentStore.setAmountFieldState("READY_FOR_PAYMENT");
  };
  getAmountHeading() {
    const { amountFieldChangedLabel, amountFieldLabel } = this.props.paymentProps;
    const { hasAmountChanged } = this.props.paymentStore;
    if (hasAmountChanged && amountFieldChangedLabel) {
      return amountFieldChangedLabel;
    }
    if (amountFieldLabel) {
      return amountFieldLabel;
    }
    if (this.props.paymentProps.brand === "SUPER") {
      return null;
    }
    return this.props.translateStore.translate("payment.amount-heading");
  }
  getCurrentAmountColor() {
    if (this.props.paymentProps.brand === "SUPER") {
      return { color: "#FDD001" };
    }
  }
  getEditAmountButton() {
    const { translate } = this.props.translateStore;
    return /* @__PURE__ */ React.createElement(
      Button,
      {
        link: true,
        text: translate("payment.amount-helper.amount"),
        onClick: () => this.props.paymentStore.setAmountFieldState("EDITING")
      }
    );
  }
}
const AmountFieldComponent$1 = inject("translateStore", "paymentStore")(observer(AmountFieldComponent));
export {
  AmountFieldComponent$1 as default
};
